import { DriverInfo } from '../../types/DriverInfo'
import { api } from './api'

export const driverApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDriverInfo: builder.query<DriverInfo, number>({
      query: (driverId) => ({
        url: `/delivery/functions/fetch-driver-info/${driverId}`,
      }),
    }),
  }),
})

export const { useGetDriverInfoQuery } = driverApi
